import { TEXTS } from 'application/pages/AdsPage/renderer/texts';

import { AdCampaignTypeEnum } from '@entities/media';

export const AD_TYPE_MAP: Record<string, string> = {
  [AdCampaignTypeEnum.Interval]: TEXTS.AD_TYPE_INTERVAL,
  [AdCampaignTypeEnum.ExactTime]: TEXTS.AD_TYPE_EXACT,
  [AdCampaignTypeEnum.Period]: TEXTS.AD_TYPE_PERIOD,
  [AdCampaignTypeEnum.Instant]: TEXTS.AD_TYPE_INSTANT,
};
